import { render, staticRenderFns } from "./PurchaseOrderSummary.vue?vue&type=template&id=6884c9e2&"
import script from "./PurchaseOrderSummary.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports